import BreadCrumbSection from "../components/breadcrumb_section";
import { Anulicense } from "../license";

const ServicesPage = () => {
  const services = [
    {
      id: "1",
      heading: "Graphic Design",
      categories: [
        {
          title: "Logo Creation",
          desc: "Professional logos that capture your brand’s vision and identity.Unique, scalable, and impactful – perfect for startups and established businesses alike.",
          img: Anulicense.ourWork28,
        },
        {
          title: "Office Stationery",
          desc: "Professional office stationery designed to reflect your brand identity with consistency. Includes letterheads, envelopes, notepads, and business cards with premium print quality.",
          img: Anulicense.service_office_stationery,
        },
        {
          title: "Brochures & Product Catalogues",
          desc: "Design and print high-quality brochures and product catalogues that showcase your offerings effectively.",
          img: Anulicense.ourWork45,
        },
        {
          title: "Stickers & Lables",
          desc: "Custom stickers and labels designed for branding, packaging, and promotions. Available in various shapes, sizes, and finishes to suit every product and purpose.",
          img: Anulicense.ourWork4,
        },
        // {
        //   title: "Corporate Branding",
        //   desc: "Corporate branding solutions that define and strengthen your brand identity.",
        //   img: Anulicense.product2,
        // },
        // {
        //   title: "Vehicle Branding",
        //   desc: " Vehicle branding solutions that transform any vehicle into a powerful marketing tool.",
        //   img: Anulicense.services1,
        // },
      ],
    },
    {
      id: "2",
      heading: "Digital Printing",
      categories: [
        {
          title: "Business Cards",
          desc: "Premium business cards that create a strong first impression and reflect your brand identity.",
          img: Anulicense.ourWork15,
        },
        {
          title: "Product Catalogue",
          desc: "Professionally designed product catalogues to showcase your offerings with clarity and style.",
          img: Anulicense.ourWork29,
        },
        {
          title: "Posters & Certificates",
          desc: "High-quality posters and certificates designed for impact, recognition, and display. Customizable layouts, vibrant prints, and premium finishes for every occasion or event.",
          img: Anulicense.services7,
        },
        {
          title: "Id Cards",
          desc: "Durable and professionally printed ID cards for schools, offices, and organizations. Custom designs with photo, barcode, QR, and security features as required.",
          img: Anulicense.ourWork12,
        },
        {
          title: "Company Profiles",
          desc: "Well-crafted company profiles that present your business professionally and persuasively.",
          img: Anulicense.ourWork30,
        },
      ],
    },
    {
      id: "3",
      heading: "Offset Printing",
      categories: [
        {
          title: "Brochures & Leaflets",
          desc: "Attractive brochures and leaflets designed to communicate your message clearly and effectively.",
          img: Anulicense.service_brochures_leaflets,
        },
        {
          title: "Diaries and Calenders",
          desc: "Custom-printed diaries and calendars ideal for corporate gifting and brand promotion. Designed with personalized layouts, branding elements, and high-quality finishes.",
          img: Anulicense.ourWork32,
        },
        {
          title: "News Letters & Annual Reports",
          desc: "Professionally designed newsletters and annual reports to communicate updates and achievements.",
          img: Anulicense.ourWork33,
        },
        {
          title: "School and College Magzines",
          desc: "Engaging and well-designed magazines that highlight student achievements, events, and creativity.",
          img: Anulicense.ourWork34,
        },
        {
          title: "Customised File Folders",
          desc: "Branded file folders designed to organize documents while promoting your identity. Available in various sizes, materials, and finishes to suit corporate and institutional needs.",
          img: Anulicense.ourWork35,
        },
      ],
    },
    {
      id: "4",
      heading: "Signage - Indoor & Outdoor",
      categories: [
        {
          title: "LED Board / 2D and 3D Boards",
          desc: "LED-lit boards to make your brand shine, day and night. Ideal for shops, restaurants, and showrooms.",
          img: Anulicense.ourWork36,
        },
        {
          title: "Pole ads",
          desc: "Strategically designed pole ads to capture public attention in high-traffic areas.",
          img: Anulicense.ourWork10,
        },
        {
          title: "Sign Boards - Front/ Back Light Board",
          desc: "High-impact front-lit and back-lit sign boards for strong day and night visibility.",
          img: Anulicense.ourWork37,
        },
        {
          title: "Sandwich Boards",
          desc: "Portable and double-sided sandwich boards ideal for sidewalk advertising and promotions.",
          img: Anulicense.service_sandwich_board,
        },
        {
          title: "Direction Boards",
          desc: "Guide your customers, clients, or visitors with professionally designed direction boards. Crafted for high visibility and easy readability – perfect for both indoor and outdoor use.",
          img: Anulicense.ourWork38,
        },
        {
          title: "lnshop Branding  (Sunboard, ACP board and Acrylic board )",
          desc: "Enhance your retail space with vibrant in-shop branding using sunboard, ACP, and acrylic boards.",
          img: Anulicense.ourWork39,
        },
      ],
    },
    {
      id: "5",
      heading: "Corporate Gifts",
      categories: [
        {
          title: "Customized Mugs",
          desc: "Personalized mugs designed for gifting, branding, and promotional purposes.",
          img: Anulicense.ourWork1,
        },
        {
          title: "Branded T-Shirts",
          desc: "Printed T-shirts with your brand’s identity. Perfect for team wear, giveaways, and promotions.",
          img: Anulicense.banner1,
        },
        {
          title: "Diaries & Planners",
          desc: "Stylish and functional diaries & planners designed for daily organization and brand promotion. Customizable covers, layouts, and branding options ideal for corporate gifting and personal use.",
          img: Anulicense.ourWork3,
        },
        {
          title: "Pens & Keychains",
          desc: "Custom-printed pens and keychains ideal for brand promotion, events, and giveaways.",
          img: Anulicense.service_keyChain,
        },
        {
          title: "Meomontoes",
          desc: "Elegant and personalized mementoes crafted to celebrate achievements and special occasions.",
          img: Anulicense.service_meomontoes,
        },
        {
          title: "Indoor Plants",
          desc: "Decorative indoor plants that enhance workspace aesthetics and promote a refreshing environment.",
          img: Anulicense.ourWork40,
        },
      ],
    },
    {
      id: "6",
      heading: "Packaging",
      categories: [
        {
          title: "Paper Bags",
          desc: "Eco-friendly paper bags designed for retail, events, and corporate branding.",
          img: Anulicense.banner3,
        },
        {
          title: "Rigid Box",
          desc: "Premium rigid boxes crafted for luxury packaging, gifting, and brand presentation.",
          img: Anulicense.ourWork5,
        },
        {
          title: "Sweet and Cake boxes",
          desc: "Attractive and sturdy sweet and cake boxes designed to preserve freshness and enhance presentation.",
          img: Anulicense.ourWork41,
        },
        {
          title: "Stickers and Lables (Rolls & Sheet)",
          desc: "High-quality stickers and labels available in both roll and sheet formats for easy application.",
          img: Anulicense.service_stickers_lables,
        },
        {
          title: "Spices & confectionery paper covers",
          desc: "Durable and food-safe paper covers designed specifically for spices and confectionery items.",
          img: Anulicense.service_spices_confectionery_paper_covers,
        },
        {
          title: "Gift boxes",
          desc: "Beautifully crafted gift boxes ideal for festive occasions, corporate gifting, and special events.",
          img: Anulicense.service_giftbox,
        },
      ],
    }
  ];

  return (
    <section id="services" className="services">
      <BreadCrumbSection page="services" />

      <div className="container mx-auto px-4 mt-20">
        {services.map((item, key) => {
          return (
            <section id={`anu-${item.heading}`} key={item.id}>
              <div id={`anu-${item.heading}`}>
                <h1 className="font-global_font text-[30px] font-bold">
                  {item.heading}
                </h1>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 py-5">
                {item.categories.map((item, idx) => (
                  <div
                    key={idx}
                    className="p-5 lg:p-5 rounded-lg bg-white shadow-md hover:shadow-xl transition-shadow duration-300"
                  >
                    <div className="flex flex-col gap-4 items-start">
                      <div className="w-full  h-[200px] sm:h-[300px]">
                        <img
                          src={item.img}
                          alt={item.title}
                          className="w-full h-full object-scale-down bg-gray-100 rounded-lg"
                        />
                      </div>
                      <div>
                        <h3 className="text-[18px] font-global_font font-semibold mb-1">
                          {item.title}
                        </h3>
                        <p className="text-[16px] text-gray-600">{item.desc}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </section>
          );
        })}
      </div>

      {/* Help Section */}
      <div className="bg-secondary px-4 md:px-[40px] py-[50px] text-white">
        <div className="container mx-auto flex flex-col md:flex-row gap-10">
          {/* Left Text Content */}
          <div className="w-full md:w-1/2">
            <div className="relative z-10">
              <h4 className="text-[#fec931] font-secondary_font text-[18px] md:text-[24px] leading-[30px] md:leading-[60px]">
                Needs Any Helps
              </h4>
              <h2 className="font-medium text-[28px] md:text-[50px] leading-[35px] md:leading-[60px]">
                Always Ready To Print Your Dream Works
              </h2>
            </div>
            <p className="mt-5 pl-2 md:pl-10 leading-[30px]">
              Every Business, from the day it is born, embarks on a journey of
              its own. The Journey of Impressive Print starts here. "Udhayam"
              means "a new dawn". We at Udhayam Achagam, always aspire to align
              our expertise and excellence with customer preferences. As our
              guiding principle, we adhere to quality standards and the value of
              time.
            </p>
          </div>

          {/* Right Image Grid */}
          <div className="grid grid-cols-2 gap-4 w-full md:w-1/2">
            <img src={Anulicense.product1} alt="Service product 1" />
            <img src={Anulicense.product2} alt="Service product 2" />
            <img src={Anulicense.ourWork7} alt="Service example 1" />
            <img src={Anulicense.ourWork14} alt="Service example 2" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesPage;
